import styled from 'styled-components';

export const MessageWarning = styled.span`
  color: red;
`;
